/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Reviews_Ratinglabel1Inputs */

const he_account_reviews_ratinglabel1 = /** @type {(inputs: Account_Reviews_Ratinglabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דירוג`)
};

const en_account_reviews_ratinglabel1 = /** @type {(inputs: Account_Reviews_Ratinglabel1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rating`)
};

/**
* | output |
* | --- |
* | "Rating" |
*
* @param {Account_Reviews_Ratinglabel1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const account_reviews_ratinglabel1 = /** @type {((inputs?: Account_Reviews_Ratinglabel1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Reviews_Ratinglabel1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_reviews_ratinglabel1(inputs)
	return en_account_reviews_ratinglabel1(inputs)
});
export { account_reviews_ratinglabel1 as "account_reviews_ratingLabel" }